import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authExchange } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const me = await authExchange(sessionId);
        // Clear the hash and refresh global auth state
        window.history.replaceState({}, "", "/admin");
        await refresh();
        if (!me.is_admin) {
          setErr("This account is not an admin. Please contact the site owner.");
          return;
        }
        navigate("/admin", { replace: true, state: { user: me } });
      } catch (e) {
        setErr("Sign in failed. Please try again.");
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        {err ? (
          <>
            <p className="font-serif text-2xl mb-3" style={{ color: "var(--jaf-primary)" }}>{err}</p>
            <button
              onClick={() => navigate("/admin/login", { replace: true })}
              className="jaf-btn-primary px-5 py-2.5 rounded-md text-sm"
            >
              Try again
            </button>
          </>
        ) : (
          <p className="text-base" style={{ color: "var(--jaf-text-muted)" }}>Signing you in…</p>
        )}
      </div>
    </div>
  );
}
